function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import cs from 'classnames';
import { Icon } from '../Icon';
export var Checkbox = function Checkbox(props) {
  var _props$tabIndex;

  return /*#__PURE__*/React.createElement("label", {
    className: "telia-checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    id: props.id,
    "aria-checked": 'checked' in props && props.checked ? 'true' : 'partial' in props && props.partial ? 'mixed' : 'false',
    "aria-controls": 'controls' in props && props.controls ? props.controls : '',
    className: "telia-checkbox__checkbox",
    type: "checkbox",
    name: props.name,
    checked: 'checked' in props && props.checked,
    disabled: props.disabled,
    onChange: 'checked' in props ? props.onChange : undefined,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        e.stopPropagation();
      }
    },
    tabIndex: (_props$tabIndex = props.tabIndex) !== null && _props$tabIndex !== void 0 ? _props$tabIndex : 0
  }), /*#__PURE__*/React.createElement("div", {
    className: "telia-checkbox__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: cs('telia-checkbox__checkbox-container', {
      'telia-checkbox__checkbox-container--checked': 'checked' in props && props.checked
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(_defineProperty({
      'telia-checkbox__icon-container': true,
      'telia-checkbox__icon-container--checked': 'partial' in props && props.partial || 'checked' in props && props.checked,
      'telia-checkbox__icon-container--disabled': props.disabled,
      'telia-checkbox__icon-container--disabled-and-checked': props.disabled && ('checked' in props && props.checked || 'partial' in props && props.partial)
    }, props.className, props.className))
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "check-mark",
    className: cs('telia-checkbox__icon', {
      'telia-checkbox__icon--visible': 'checked' in props && props.checked
    }),
    style: {
      width: '1rem',
      height: '1rem'
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "minus",
    className: cs('telia-checkbox__icon', {
      'telia-checkbox__icon--visible': 'checked' in props && !props.checked && 'partial' in props && props.partial
    }),
    style: {
      width: '1rem',
      height: '1rem'
    }
  })), ' '), /*#__PURE__*/React.createElement("span", {
    className: cs('telia-checkbox__label', {
      'telia-checkbox__label--visually-hidden': props.hiddenLabel
    })
  }, props.label)));
};